export const getCriticalityLabel = (score?: number | null) => {
  if (score === null || score === undefined || isNaN(score)) {
    return { label: "N/A", color: "text-gray-400" };
  }
  if (score >= 0 && score <= 25) {
    return { label: "Low", color: "text-red-600" };
  } else if (score <= 50) {
    return { label: "Medium", color: "text-orange-600" };
  } else if (score <= 75) {
    return { label: "High", color: "text-blue-600" };
  } else {
    return { label: "Critical", color: "text-green-600" };
  }
};

export const getConditionLabel = (score?: number | null) => {
  if (score === null || score === undefined || isNaN(score)) {
    return { label: "N/A", color: "text-gray-400" };
  }
  if (score >= 0 && score < 20) {
    return { label: "Critical", color: "text-red-600" };
  } else if (score < 40) {
    return { label: "Poor", color: "text-orange-600" };
  } else if (score < 60) {
    return { label: "Fair", color: "text-yellow-600" };
  } else if (score < 80) {
    return { label: "Good", color: "text-blue-600" };
  } else {
    return { label: "Excellent", color: "text-green-600" };
  }
};
